import * as React from "react";
import { PaginationContainerMain } from "./styles";

interface PaginationProps {
  totalPages?: number;
  currentPage?: number;
  setCurrentPage: (page: number) => void;
  prevBtnLabel?: string | React.ReactNode;
  nextBtnLabel?: string | React.ReactNode;
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages = 10,
  currentPage = 1,
  setCurrentPage,
  prevBtnLabel = "Prev",
  nextBtnLabel = "Next",
  
}) => {
  const handlePageChange = (page: number) => {
    if(setCurrentPage) {
      setCurrentPage(page);
    } else {
      console.error("setCurrentPage function is not provided. Please pass the setCurrentPage function to enable pagination.")
    }
  };

  const renderPagination = (): React.ReactNode[] => {
    const liTags: React.ReactNode[] = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    if (currentPage > 2) {
      liTags.push(
        <li
          key="first"
          className={`first numb`}
          onClick={() => handlePageChange(1)}
        >
          <span>1</span>
        </li>
      );
      if (currentPage > 3) {
        liTags.push(
          <li key="dots1" className={`dots`}>
            <span>...</span>
          </li>
        );
      }
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages) {
        continue;
      }
      if (plength === 0) {
        plength = plength + 1;
      }
      liTags.push(
        <li
          key={plength}
          className={`numb ${currentPage === plength ? "active" : ""}`}
          onClick={() => handlePageChange(plength)}
        >
          <span>{plength}</span>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTags.push(
          <li key="dots2" className={`dots`}>
            <span>...</span>
          </li>
        );
      }
      liTags.push(
        <li
          key="last"
          className={`last numb`}
          onClick={() => handlePageChange(totalPages)}
        >
          <span>{totalPages}</span>
        </li>
      );
    }
    return liTags;
  };

  return (
    <PaginationContainerMain>
      <button
        disabled={!(currentPage > 1)}
        className={`btn prev`}
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
      >
        {prevBtnLabel}
      </button>
      <ul>{renderPagination()}</ul>
      <button
        disabled={!(currentPage < totalPages)}
        className={`btn next`}
        onClick={() =>
          currentPage < totalPages && handlePageChange(currentPage + 1)
        }
      >
        {nextBtnLabel}
      </button>
    </PaginationContainerMain>
  );
};

export { Pagination };
